import angular from 'angular';
import { ModalConfirmService } from '../../../../../shared/components/modal-confirm/modal.confirm.service';
import {
    IMovimentacao,
    IMovimentacaoHistoricoResumo
} from '../../../models/movimentacoes.service.model';
import { IMovimentacaoPeriodo } from '../../../models/movimentacoes-periodos.service.model';
import { IMovimentacaoWorkflowAcao } from '../../../models/movimentacoes-workflow.service.model';
import { MovimentacoesService } from '../../../movimentacoes.service';
import { MovimentacoesWorkflowService } from '../../../movimentacoes-workflow.service';
import {
    IMovimentacaoHistoricoItemView,
    IMovimentacaoDetalheEditContext,
    IMovimentacaoDrawerPermissionContext,
    IMovimentacaoDrawerSummaryViewModel,
    IMovimentacoesDetalheDrawerBindings,
    TMovimentacaoDrawerAction,
    TMovimentacaoDrawerActionExecutor
} from './movimentacoes-detalhe-drawer.model';
import { IMovimentacaoFormState } from '../movimentacao-form/movimentacoes-movimentacao-form.model';
import {
    buildMovimentacaoDetalheActionTexts,
    buildMovimentacaoDrawerSummaryView,
    buildMovimentacaoEditModel,
    buildMovimentacaoHistoricoItems,
    buildMovimentacaoUpdatePayload,
    buildMovimentacaoWorkflowActionTexts,
    buildMovimentacaoWorkflowModalAction,
    canCancelMovimentacaoDrawer,
    canDeleteMovimentacaoDrawer,
    canEditMovimentacaoDrawer,
    canSaveMovimentacaoDrawerEdit,
    canSendMovimentacaoDrawer,
    getMovimentacaoDetalheSubtitle,
    getMovimentacaoDrawerErrorMessage,
    getMovimentacaoDrawerSuccessMessage,
    getMovimentacaoWorkflowActionButtonClass,
    getMovimentacaoWorkflowActionErrorMessage,
    getMovimentacaoWorkflowActionSuccessMessage
} from '../../helpers/movimentacoes-detalhe-ui.helpers';
import { extractMovimentacaoErrorMessage } from '../../helpers/movimentacoes-errors.helpers';
import { getMovimentacaoDisplayStatusClass, getMovimentacaoDisplayStatusLabel } from '../../helpers/movimentacoes-list-ui.helpers';
import { isMovimentacaoPeriodoEncerrado } from '../../helpers/movimentacoes-form.helpers';
import { WorkflowOldModalService } from '../../../../Workflow/modais/oldModal/workflow.old.service';

export class MovimentacoesDetalheDrawerController implements angular.IController, IMovimentacoesDetalheDrawerBindings {
    static $inject = ['$q', '$rootScope', '$filter', 'MovimentacoesService', 'MovimentacoesWorkflowService', 'ModalConfirmService', 'WorkflowOldModalService', 'NewToaster'];

    public opened = false;
    public movimentacaoId: string | null = null;
    public selectedPeriod: IMovimentacaoPeriodo | null = null;
    public canManage = false;
    public workflowEnabled = false;
    public onClose?: () => void;
    public onChanged?: () => void;

    public loading = false;
    public loadError = false;
    public actionBusy = false;
    public detail: IMovimentacao | null = null;
    public colaboradorFotoUrl: string | null = null;
    public summaryView: IMovimentacaoDrawerSummaryViewModel | null = null;
    public historicoItems: IMovimentacaoHistoricoItemView[] = [];
    public workflowActions: IMovimentacaoWorkflowAcao[] = [];
    public editContext: IMovimentacaoDetalheEditContext = {
        mode: 'view',
        model: null,
        state: {
            valid: false,
            vigenciaFinalInvalida: false
        }
    };

    constructor(
        public $q: angular.IQService,
        public $rootScope: angular.IRootScopeService & {
            usuario?: {
                email?: string;
            };
        },
        public $filter: angular.IFilterFunction,
        public MovimentacoesService: MovimentacoesService,
        public MovimentacoesWorkflowService: MovimentacoesWorkflowService,
        public ModalConfirmService: ModalConfirmService,
        public WorkflowOldModalService: WorkflowOldModalService,
        public NewToaster: {
            pop: (opts: { type: string; title: string; body?: string }) => void;
        }
    ) { }

    public $onChanges(changes: angular.IOnChangesObject): void {
        const shouldLoad = this.opened && !!this.movimentacaoId;
        const openedChanged = !!changes.opened && changes.opened.currentValue === true;
        const movimentacaoChanged = !!changes.movimentacaoId && !changes.movimentacaoId.isFirstChange();
        const workflowChanged = !!changes.workflowEnabled && !changes.workflowEnabled.isFirstChange();

        if (shouldLoad && (openedChanged || movimentacaoChanged || workflowChanged)) {
            this.load();
        }

        if (!this.opened) {
            this.reset();
        }
    }

    public close(): void {
        if (this.actionBusy) {
            return;
        }

        this.cancelEdit();
        if (this.onClose) {
            this.onClose();
        }
    }

    public hasHistorico(): boolean {
        return this.historicoItems.length > 0;
    }

    public isEditMode(): boolean {
        return this.editContext.mode === 'edit';
    }

    public canEdit(): boolean {
        return canEditMovimentacaoDrawer(this.buildPermissionContext());
    }

    public canDelete(): boolean {
        return canDeleteMovimentacaoDrawer(this.buildPermissionContext());
    }

    public canSend(): boolean {
        return canSendMovimentacaoDrawer(this.buildPermissionContext());
    }

    public canCancel(): boolean {
        return canCancelMovimentacaoDrawer(this.buildPermissionContext());
    }

    public canSaveEdit(): boolean {
        return canSaveMovimentacaoDrawerEdit(this.buildPermissionContext());
    }

    public getTitle(): string {
        if (!this.detail) {
            return 'Detalhes da movimentação';
        }

        const codigo = this.detail.evento?.codigo || '';
        const nome = this.detail.evento?.nome || '';

        if (codigo && nome) {
            return `${codigo} - ${nome}`;
        }

        return nome || 'Detalhes da movimentação';
    }

    public getSubtitle(): string {
        return getMovimentacaoDetalheSubtitle(this.detail, this.selectedPeriod);
    }

    public getBadgeLabel(): string {
        if (!this.detail) {
            return '';
        }

        return getMovimentacaoDisplayStatusLabel(this.detail, this.workflowEnabled);
    }

    public getBadgeClass(): string {
        if (!this.detail) {
            return 'label-default';
        }

        return getMovimentacaoDisplayStatusClass(this.detail, this.workflowEnabled);
    }

    public hasWorkflowActions(): boolean {
        return this.workflowActions.length > 0;
    }

    public getWorkflowActionButtonClass(action: IMovimentacaoWorkflowAcao): string {
        return getMovimentacaoWorkflowActionButtonClass(action);
    }

    public startEdit(): void {
        if (!this.canEdit() || !this.detail) {
            return;
        }

        this.editContext = {
            mode: 'edit',
            model: buildMovimentacaoEditModel(this.detail),
            state: {
                valid: false,
                vigenciaFinalInvalida: false
            }
        };
    }

    public cancelEdit(): void {
        this.editContext = {
            mode: 'view',
            model: null,
            state: {
                valid: false,
                vigenciaFinalInvalida: false
            }
        };
    }

    public onEditValidityChange(state: IMovimentacaoFormState): void {
        this.editContext.state.valid = !!state.valid;
        this.editContext.state.vigenciaFinalInvalida = !!state.vigenciaFinalInvalida;
    }

    public saveEdit(): void {
        if (!this.canManage || !this.detail || !this.editContext.model) {
            return;
        }

        if (this.isSelectedPeriodClosed()) {
            this.notifyPeriodoEncerrado();
            return;
        }

        if (this.editContext.state.formRef) {
            this.editContext.state.formRef.$setSubmitted();
        }

        if (!this.canSaveEdit()) {
            return;
        }

        this.actionBusy = true;

        this.MovimentacoesService.update(
            this.detail.movimentacao,
            buildMovimentacaoUpdatePayload(this.editContext.model, this.detail.versao)
        )
            .then(() => this.reloadDetail())
            .then(() => {
                this.cancelEdit();
                this.emitChanged();
                this.NewToaster.pop({
                    type: 'success',
                    title: 'Movimentação atualizada com sucesso.'
                });
            })
            .catch((error) => {
                this.handleActionError(error, 'Não foi possível atualizar a movimentação.');
            })
            .finally(() => {
                this.actionBusy = false;
            });
    }

    public confirmDelete(): void {
        if (!this.detail || !this.canDelete()) {
            return;
        }

        const modal = this.ModalConfirmService.open(
            this.detail,
            'movimentação',
            false,
            buildMovimentacaoDetalheActionTexts('delete')
        );

        modal.result
            .then(() => this.executeConfirmedAction('delete', () => this.MovimentacoesService.remove(this.detail!.movimentacao), true))
            .catch(() => { /* noop */ });
    }

    public confirmSend(): void {
        if (!this.detail || !this.canSend()) {
            return;
        }

        const modal = this.ModalConfirmService.open(
            this.detail,
            'movimentação',
            false,
            buildMovimentacaoDetalheActionTexts('send')
        );

        modal.result
            .then(() => this.executeConfirmedAction('send', () => this.MovimentacoesService.enviar(this.detail!.movimentacao)))
            .catch(() => { /* noop */ });
    }

    public confirmCancel(): void {
        if (!this.detail || !this.canCancel()) {
            return;
        }

        const modal = this.ModalConfirmService.open(
            this.detail,
            'movimentação enviada',
            false,
            buildMovimentacaoDetalheActionTexts('cancel')
        );

        modal.result
            .then(() => this.executeConfirmedAction('cancel', () => this.MovimentacoesService.cancelar(this.detail!.movimentacao)))
            .catch(() => { /* noop */ });
    }

    public triggerWorkflowAction(action: IMovimentacaoWorkflowAcao): void {
        if (!this.detail || !this.canManage || this.actionBusy || this.isEditMode() || this.isSelectedPeriodClosed()) {
            return;
        }

        if (action.exigirmotivo) {
            const modal = this.WorkflowOldModalService.open(
                buildMovimentacaoWorkflowModalAction(action),
                { nome: this.detail.trabalhador?.nome || '' } as any
            );

            modal.result
                .then((resolvedAction: any) => this.executeWorkflowAction(action, resolvedAction?.comentario || null))
                .catch(() => { /* noop */ });
            return;
        }

        const modal = this.ModalConfirmService.open(
            this.detail,
            'movimentação',
            false,
            buildMovimentacaoWorkflowActionTexts(action.codigo)
        );

        modal.result
            .then(() => this.executeWorkflowAction(action, null))
            .catch(() => { /* noop */ });
    }

    private executeConfirmedAction(
        action: TMovimentacaoDrawerAction,
        executor: TMovimentacaoDrawerActionExecutor,
        closeAfterSuccess: boolean = false
    ): void {
        if (this.isSelectedPeriodClosed()) {
            this.notifyPeriodoEncerrado();
            return;
        }

        this.actionBusy = true;

        executor()
            .then(() => closeAfterSuccess ? this.$q.resolve() : this.reloadDetail())
            .then(() => {
                this.emitChanged();

                if (closeAfterSuccess) {
                    if (this.onClose) {
                        this.onClose();
                    }
                }

                this.NewToaster.pop({
                    type: 'success',
                    title: getMovimentacaoDrawerSuccessMessage(action)
                });
            })
            .catch((error) => {
                this.handleActionError(error, getMovimentacaoDrawerErrorMessage(action));
            })
            .finally(() => {
                this.actionBusy = false;
            });
    }

    private load(): void {
        if (!this.movimentacaoId) {
            this.reset();
            return;
        }

        this.loading = true;
        this.loadError = false;

        this.$q.all([
            this.MovimentacoesService.get(this.movimentacaoId),
            this.MovimentacoesService.listHistoricos(this.movimentacaoId, { order: { ordem: 'ASC' } }),
            this.loadWorkflowActions(this.movimentacaoId)
        ])
            .then(([detail, historicos, workflowActions]) => {
                this.applyLoadedDetailState(detail, historicos, workflowActions);
            })
            .catch(() => {
                this.detail = null;
                this.colaboradorFotoUrl = null;
                this.summaryView = null;
                this.historicoItems = [];
                this.workflowActions = [];
                this.loadError = true;
            })
            .finally(() => {
                this.loading = false;
            });
    }

    private reloadDetail(): angular.IPromise<void> {
        if (!this.movimentacaoId) {
            return this.$q.resolve();
        }

        return this.$q.all([
            this.MovimentacoesService.get(this.movimentacaoId),
            this.MovimentacoesService.listHistoricos(this.movimentacaoId, { order: { ordem: 'ASC' } }),
            this.loadWorkflowActions(this.movimentacaoId)
        ])
            .then(([detail, historicos, workflowActions]) => {
                this.applyLoadedDetailState(detail, historicos, workflowActions);
                this.loadError = false;
            });
    }

    private reset(): void {
        this.loading = false;
        this.loadError = false;
        this.actionBusy = false;
        this.detail = null;
        this.colaboradorFotoUrl = null;
        this.summaryView = null;
        this.historicoItems = [];
        this.workflowActions = [];
        this.cancelEdit();
    }

    private emitChanged(): void {
        if (this.onChanged) {
            this.onChanged();
        }
    }

    private isSelectedPeriodClosed(): boolean {
        return isMovimentacaoPeriodoEncerrado(this.selectedPeriod);
    }

    private notifyPeriodoEncerrado(): void {
        this.NewToaster.pop({
            type: 'error',
            title: 'Período encerrado.',
            body: 'Períodos encerrados não permitem alterações em movimentações.'
        });
    }

    private handleActionError(error: any, fallbackMessage: string): void {
        const message = extractMovimentacaoErrorMessage(error) || fallbackMessage;

        this.NewToaster.pop({
            type: 'error',
            title: fallbackMessage,
            body: message !== fallbackMessage ? message : undefined
        });
    }

    private buildPermissionContext(): IMovimentacaoDrawerPermissionContext {
        return {
            canManage: this.canManage,
            workflowEnabled: this.workflowEnabled,
            currentUserEmail: this.$rootScope.usuario?.email || '',
            actionBusy: this.actionBusy,
            isEditMode: this.isEditMode(),
            selectedPeriodClosed: this.isSelectedPeriodClosed(),
            detail: this.detail,
            editState: this.editContext.state
        };
    }

    private applyLoadedDetailState(
        detail: IMovimentacao,
        historicos: IMovimentacaoHistoricoResumo[],
        workflowActions: IMovimentacaoWorkflowAcao[]
    ): void {
        this.detail = detail;
        this.colaboradorFotoUrl = null;
        this.summaryView = buildMovimentacaoDrawerSummaryView(detail, this.$filter, this.colaboradorFotoUrl);
        this.historicoItems = buildMovimentacaoHistoricoItems(historicos);
        this.workflowActions = workflowActions;
        this.loadColaboradorFoto(detail);
    }

    private loadColaboradorFoto(detail: IMovimentacao): void {
        const trabalhadorId = detail?.trabalhador?.trabalhador;
        const movimentacaoId = detail?.movimentacao;

        if (!trabalhadorId || !movimentacaoId) {
            return;
        }

        this.MovimentacoesService.getTrabalhadorFoto(trabalhadorId)
            .then((url: string) => {
                if (!url) {
                    return;
                }

                if (this.detail?.movimentacao !== movimentacaoId || this.detail?.trabalhador?.trabalhador !== trabalhadorId) {
                    return;
                }

                this.colaboradorFotoUrl = url;
                this.summaryView = buildMovimentacaoDrawerSummaryView(this.detail, this.$filter, url);
            })
            .catch(() => {
                // sem foto
            });
    }

    private executeWorkflowAction(action: IMovimentacaoWorkflowAcao, motivo: string | null): void {
        if (!this.detail) {
            return;
        }

        this.actionBusy = true;

        this.MovimentacoesWorkflowService.executarWorkflowAcao(this.detail.movimentacao, action.codigo, motivo)
            .then(() => this.reloadDetail())
            .then(() => {
                this.emitChanged();
                this.NewToaster.pop({
                    type: 'success',
                    title: getMovimentacaoWorkflowActionSuccessMessage(action.codigo)
                });
            })
            .catch((error) => {
                this.handleActionError(error, getMovimentacaoWorkflowActionErrorMessage(action.codigo));
            })
            .finally(() => {
                this.actionBusy = false;
            });
    }

    private loadWorkflowActions(identifier: string): angular.IPromise<IMovimentacaoWorkflowAcao[]> {
        if (!this.workflowEnabled) {
            return this.$q.resolve([]);
        }

        return this.MovimentacoesWorkflowService.listWorkflowAcoes(identifier)
            .catch(() => []);
    }
}
